import { eyeColorList } from "../helper";
import FilterMultiSelectBox from "./filterMultiSelectBox";
import { useEyeColorFilter } from "../filters/useEyeColorFilter";

const FilterEyeColor = ({ talentFilter, talentFilterTags, onAddFilter }) => {
  const {
    values,
    setValues,
    isDisabled,
    buildEyeColorFilter,
  } = useEyeColorFilter(talentFilter, talentFilterTags);

  const handleAdd = () => {
    const payload = buildEyeColorFilter();
    if (!payload) return;

    onAddFilter("eye_color", payload);
  };

  return (
    <FilterMultiSelectBox
      title="EYE COLOR (Select one or several)"
      label="Select eye color or search"
      list={eyeColorList}
      selectedValue={values}
      onChange={setValues}
      onAddFilter={handleAdd}
      btnContent="Add Filter"
      disabled={isDisabled}
    />
  );
};

export default FilterEyeColor;
